export default __webpack_public_path__ + "static/media/pdfIcon.308eae89.png";